import { motion } from "framer-motion";
import { Phone } from "lucide-react";

export const CallButton = () => (
  <motion.a
    href="tel:+33760405373"
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 2, duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
    data-testid="mobile-call-button"
    className="fixed bottom-6 right-6 z-40 md:hidden flex items-center gap-3 bg-gold text-obsidian px-6 py-4 text-xs uppercase tracking-[0.25em] font-medium shadow-[0_10px_40px_rgba(227,154,59,0.35)] active:scale-95 transition-transform duration-200"
  >
    <Phone className="w-4 h-4" />
    Appeler
  </motion.a>
);
